import businessGetters from '@/store/getters/business'
import menuGetters from '@/store/getters/menu'
import reservationGetters from '@/store/getters/reservation'
import businessApi from '@/API/business-api'

export default {
  namespaced: true,
  state: {
    infoFetched: false,
    redirect: '',
    standardLayoutList: false,
    business: {},
    currentItem: null,
    menu: [],
    currentCategory: null,
    currentSellingType: '',
    currentSellingTypeSettings: {
      cash: 1,
      pay_with_card: 0,
      credit: 0,
      pay_later: 0,
      notes: '',
      min_order: 0,
    },
    _appWidth: 375,
    _showBranchesModal: false,
    language: '',
    theme: 'light',
    activeBranchRef: null,
    windowWidth: 480,
    storeId: null,
    itemById: null,
    branchesList: [],
    branchesListFetched: false,
    hasBackground: false,
    pixels: [],
  },
  getters: {
    ...businessGetters,
    ...menuGetters,
    ...reservationGetters,
    menuItems: (state: any) => state.menu,
  },
  mutations: {
    SET_BUSINESS(state: any, business: any) {
      state.business = business.restaurant
      state.menu = business.menu || []
    },
  },
  actions: {
    async FETCH_DATA(context: any, selectedReferenceId?: any) {
      const referenceIdData = (await businessApi.BranchData(selectedReferenceId))
      context.commit('SET_BUSINESS', referenceIdData)
    },
  },
}
